










































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Overlay extends Vue {
  @Prop({ default: false }) readonly open!: boolean;

  @Prop({ default: 'calc(var(--vh, 1vh) * 100 - 102px)' }) readonly height!: string;

  @Prop({ default: '500px' }) readonly width!: string;

  @Prop() readonly minWidth?: string;

  @Prop({ default: true }) readonly rounded!: boolean;

  @Prop({ default: '#fff' }) readonly color!: string;

  mounted() {
    const target = this.$refs.popup;
    // @ts-ignore
    document.getElementById('app').appendChild(target);
  }

  get contentStyle() {
    if (window.innerWidth > 1023.98) {
      return {
        height: 'auto',
        width: this.width,
        background: this.color,
        ...(this.minWidth !== undefined && { minWidth: this.minWidth }),
      };
    }

    return { height: this.height, width: '100%', background: this.color };
  }
}
